<!-- <div class="flex justify-center"> -->
    <p-stepper [value]="activeStep">
        <p-step-list>
            <ng-container *ngFor="let step of activeSteps;let i = index">
                <p-step *ngIf="step.visible" [value]="step.value" class="">
                    <ng-template #content let-value="value">
                        <div class="inner-container text-center">

                            <label id="place-order-stepper-{{i+1}}" class="step-circle " [ngClass]="{
                                    'active': activeStep === step.value,
                                    'completed': step.status === 'completed' && activeStep != step.value,
                                    'inComplete': step.status === 'inComplete' && activeStep != step.value
                                }" (click)="setCurrentStep(step)">
                                <span class="white-bdr">
                                    <i
                                        [ngClass]="step.status === 'completed' && activeStep != step.value  ? 'fa fa-check' : step.icon "></i>
                                </span>
                            </label>
                            <br>
                            <label [ngClass]="">{{step.label}}</label>

                        </div>
                    </ng-template>
                </p-step>
            </ng-container>

        </p-step-list>
        <p-step-panels>
            <p-step-panel [value]="1">
                <ng-template #content>
                    <app-order-info [formData]="orderInfoData" (orderTypeChange)="updateStepper($event)" (formChanged)="onFormChange()" [states]="states"></app-order-info>
                </ng-template>
            </p-step-panel>

            <p-step-panel [value]="2">
                <ng-template #content>
                    <app-subjects [formData]="subjectsData" [orderType]="orderInfoData.selectedCategory" (formChanged)="onFormChange()"></app-subjects>
                </ng-template>
            </p-step-panel>

            <p-step-panel [value]="3">
                <ng-template #content>
                    <app-subpoena [subjects]="subjectsData" [formData]="subpoenaData" (formChanged)="onFormChange()" [states]="states"></app-subpoena>
                </ng-template>
            </p-step-panel>
            <p-step-panel [value]="4">
                <ng-template #content>
                    <app-authorization [subjects]="subjectsData" [formData]="authorizationData" (formChanged)="onFormChange()" [states]="states"></app-authorization>
                </ng-template>
            </p-step-panel>
            <p-step-panel [value]="5">
                <ng-template #content>
                    <app-records [subjects]="subjectsData" [formData]="recordsData" [selectedCategory]="orderInfoData.selectedCategory" (formChanged)="onFormChange()" [states]="states"></app-records>
                </ng-template>
            </p-step-panel>
        </p-step-panels>
        <hr />
        <div class="d-flex justify-content-end">
            <p-button id="place-order-back" label="Back" severity="secondary" (onClick)="onPrevious()" [disabled]="activeStep === 1" />
            <p-button id="place-order-next-step" *ngIf="!isLastStep()" label="Next Step" (onClick)="onNext()" class="ms-3" />
            <p-button id="place-order-finish" *ngIf="isLastStep()" label="Finish" (onClick)="onFinish()" class="ms-3" [disabled]="isFormSubmitted"/>
        </div>

    </p-stepper>
    <p-toast position="top-center" severity="warn" />
<!-- </div> -->